// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * A role's explicit decision about one permission-catalogue key.
 *
 * Mirrors `LiftCloud`'s `permissions.Grant` field for field; `key` is the
 * catalogue key the `permission_grants` map is keyed by. Every flag defaults
 * to false, which is the Go zero value, so an omitted flag means "off" in
 * every language.
 */
export class RolePermissionGrant implements flatbuffers.IUnpackableObject<RolePermissionGrantT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): RolePermissionGrant {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsRolePermissionGrant(
    bb: flatbuffers.ByteBuffer,
    obj?: RolePermissionGrant,
  ): RolePermissionGrant {
    return (obj || new RolePermissionGrant()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsRolePermissionGrant(
    bb: flatbuffers.ByteBuffer,
    obj?: RolePermissionGrant,
  ): RolePermissionGrant {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new RolePermissionGrant()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  key(): string | null;
  key(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  key(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  active(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  offline(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  locked(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startRolePermissionGrant(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, keyOffset, 0);
  }

  static addActive(builder: flatbuffers.Builder, active: boolean) {
    builder.addFieldInt8(1, +active, +false);
  }

  static addOffline(builder: flatbuffers.Builder, offline: boolean) {
    builder.addFieldInt8(2, +offline, +false);
  }

  static addLocked(builder: flatbuffers.Builder, locked: boolean) {
    builder.addFieldInt8(3, +locked, +false);
  }

  static endRolePermissionGrant(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createRolePermissionGrant(
    builder: flatbuffers.Builder,
    keyOffset: flatbuffers.Offset,
    active: boolean,
    offline: boolean,
    locked: boolean,
  ): flatbuffers.Offset {
    RolePermissionGrant.startRolePermissionGrant(builder);
    RolePermissionGrant.addKey(builder, keyOffset);
    RolePermissionGrant.addActive(builder, active);
    RolePermissionGrant.addOffline(builder, offline);
    RolePermissionGrant.addLocked(builder, locked);
    return RolePermissionGrant.endRolePermissionGrant(builder);
  }

  unpack(): RolePermissionGrantT {
    return new RolePermissionGrantT(this.key(), this.active(), this.offline(), this.locked());
  }

  unpackTo(_o: RolePermissionGrantT): void {
    _o.key = this.key();
    _o.active = this.active();
    _o.offline = this.offline();
    _o.locked = this.locked();
  }

  unpackFields(...fields: string[]): RolePermissionGrantT {
    const t = new RolePermissionGrantT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key();
    }
    if (fieldSet.has("active")) {
      t.active = this.active();
    }
    if (fieldSet.has("offline")) {
      t.offline = this.offline();
    }
    if (fieldSet.has("locked")) {
      t.locked = this.locked();
    }
    return t;
  }
}

export class RolePermissionGrantT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: string | Uint8Array | null = null,
    public active: boolean = false,
    public offline: boolean = false,
    public locked: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const key = this.key !== null ? builder.createString(this.key!) : 0;

    return RolePermissionGrant.createRolePermissionGrant(
      builder,
      key,
      this.active,
      this.offline,
      this.locked,
    );
  }

  clone(): RolePermissionGrantT {
    const obj = new RolePermissionGrantT();
    obj.key = this.key;
    obj.active = this.active;
    obj.offline = this.offline;
    obj.locked = this.locked;
    return obj;
  }

  equals(other: RolePermissionGrantT): boolean {
    if (this.key !== other.key) return false;
    if (this.active !== other.active) return false;
    if (this.offline !== other.offline) return false;
    if (this.locked !== other.locked) return false;
    return true;
  }
}

export function verifyRolePermissionGrant(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 6, 1);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
  } finally {
    verifier.popDepth();
  }
}
